import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import { statusList3 } from "@/utils/constant";
import {
    Table,
    message,
    Row,
    Col,
    Card,
    Modal,
    Select,
    Button,
    List,
    Pagination,
    DatePicker,
    Input,
    InputNumber,
    Form,
    Descriptions,
    Spin,
    Radio,
    Empty,
} from "antd";
import HandDetail from "@/pages/commom/HandDetail";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

let timer;
export default class MttRoundList extends React.Component {
    state = {
        loading: false, // 是否加载中
        detailLoading: false, // 手牌详情是否加载中
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined,
            mid: undefined,
            name: undefined,
            date: [],
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
            tid: undefined,
            mid: undefined,
            uid: undefined,
        },
        statusList: statusList3, // 状态列表
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        tableBoardList: [], // 牌桌列表
        handCardData: {}, // 手牌详情
        recordData: {}, // 战绩详情
        playerData: [], // 玩家列表
        statisticsData: [], // 数据统计
        robotListData: [], // 机器人列表
        robotTableBoardListData: [], // 机器人牌桌列表
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/mtt/match/list", {
                params: {
                    ...this.state.queryParams,
                    page_size: this.state.queryParams.page,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                    page: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取牌桌列表
     */
    fetchTableList = () => {
        axios
            .get("/v1/api/mtt/match/tables", {
                params: {
                    mid: this.state.detailQueryParams.mid,
                },
            })
            .then((res) => {
                this.setState({
                    tableBoardList: res.data || [],
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        tid: res.data && res.data[0] ? res.data[0].tid : undefined,
                    },
                });
            });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/mtt/hand/detail", {
                params: {
                    ...this.state.detailQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData: res.data ? res.data[0] : {},
                });
            });
    };

    /**
     * 获取战绩详情数据
     */
    fetchRecodData = () => {
        this.setState({ detailLoading: true });
        axios
            .get(`/v1/api/mtt/match/result`, {
                params: {
                    mid: this.state.detailQueryParams.mid,
                    ...this.state.detailQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    recordData: res.data || {},
                });
            });
    };

    /**
     * 获取玩家列表数据
     */
    fetchPlayerData = () => {
        this.setState({ detailLoading: true });
        axios
            .get(`/v1/api/mtt/match/players`, {
                params: {
                    mid: this.state.detailQueryParams.mid,
                    ...this.state.detailQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    playerData: res.data || [],
                });
            });
    };

    /**
     * 获取统计数据
     */
    fetchStatisticsData = () => {
        this.setState({ detailLoading: true });
        axios
            .get(`/v1/api/mtt/match/stat/${this.state.detailQueryParams.mid}`)
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    statisticsData: res.data || {},
                });
            });
    };

    /**
     * 获取机器人列表数据
     */
    fetchRobotListData = (showLoading = true) => {
        if (showLoading) this.setState({ detailLoading: true });
        axios
            .get(`/v1/api/mtt/bot/available_list`, {
                params: {
                    mid: this.state.detailQueryParams.mid,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    show: true,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.data ? res.data.length : 0,
                    },
                    robotListData: res.data || [],
                });
            });
    };

    /**
     * 获取机器人牌桌列表数据
     */
    fetchRobotBoardListData = (showLoading = true) => {
        if (showLoading) this.setState({ detailLoading: true });
        axios
            .get(`/v1/api/mtt/bot/playing_list`, {
                params: {
                    mid: this.state.detailQueryParams.mid,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    show: true,
                    robotTableBoardListData: res.data || [],
                });
            });
    };

    /**
     * 机器人报名
     */
    handleRobotSignUp = (type, item, index) => {
        if (type === "batch") {
            // 批量报名
            this.formRef.props.form.validateFields((err, values) => {
                if (!err) {
                    if (!values.count)
                        return message.error(this.props.language["batchApplyPeopleVerify"]);
                    axios
                        .post("/v1/api/mtt/bot/register", {
                            mid: this.state.detailQueryParams.mid,
                            count: values.count,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(
                                    this.props.language["batchApplaySuccessMessage"]
                                );
                                this.formRef.props.form.resetFields();
                                this.fetchRobotListData();
                            }
                        });
                }
            });
        } else {
            // 单个报名
            axios
                .post("/v1/api/mtt/bot/register", {
                    mid: this.state.detailQueryParams.mid,
                    bot_id: item.uid,
                })
                .then((res) => {
                    if (res.code === 1) {
                        message.success(this.props.language["applySuccessMessage"]);
                        let robotListData = [...this.state.robotListData];
                        robotListData[index] = { ...item, status: 1 };
                        this.setState({ robotListData: robotListData });
                    }
                });
        }
    };

    /**
     * 机器人取消报名
     */
    handleRobotCancelSignUp = (item, index) => {
        axios
            .post("/v1/api/mtt/bot/unregister", {
                mid: this.state.detailQueryParams.mid,
                bot_id: item.uid,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["cancelApplySuccessMessage"]);
                    let robotListData = [...this.state.robotListData];
                    robotListData[index] = { ...item, status: 0 };
                    this.setState({ robotListData: robotListData });
                }
            });
    };

    /**
     * 操作机器人
     */
    handleOperationRobot = (item, type, value) => {
        axios
            .post("/v1/api/mtt/bot/update_settings", {
                mid: this.state.detailQueryParams.mid,
                bot_id: item.uid,
                auto_rebuy: type === "rebuy" ? value : undefined,
                auto_add_on: type === "addon" ? value : undefined,
                auto_action: type === "action" ? value : undefined,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["operationSuccessMessage"]);
                    this.fetchRobotBoardListData();
                }
            });
    };

    /**
     * 改变数据分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "data") {
            // 数据分页
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        } else if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else if (type === "record") {
            // 战绩详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchRecodData()
            );
        } else if (type === "player") {
            // 玩家列表数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchPlayerData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "data") {
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        } else if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => {
                    this.fetchHandCardData();
                }
            );
        }
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined,
                    mid: undefined,
                    name: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 显示弹窗
     */
    handleShow = (item, type) => {
        if (type === "robot") {
            // 测试工具
            this.setState(
                {
                    title: this.props.language["testTool"],
                    type,
                    show: true,
                    selectedData: item,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        mid: item.mid_,
                    },
                },
                () => {
                    if (item.status === 3)
                        return message.error(this.props.language["matchEndMessage"]);
                    this.setTimmer();
                }
            );
        } else if (type === "handCard") {
            // 手牌详情
            this.setState(
                {
                    title: this.props.language["handDetail"],
                    type,
                    show: true,
                    selectedData: item,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        limit: 1,
                        mid: item.mid_,
                        uid: undefined,
                    },
                },
                () => {
                    this.fetchTableList();
                    this.fetchHandCardData();
                }
            );
        } else if (type === "record") {
            // 战绩详情
            this.setState(
                {
                    title: this.props.language["recordDetail"],
                    type,
                    show: true,
                    selectedData: item,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        limit: 1,
                        mid: item.mid_,
                    },
                },
                () => this.fetchRecodData()
            );
        } else if (type === "player") {
            // 玩家列表
            this.setState(
                {
                    title: this.props.language["playerList"],
                    type,
                    show: true,
                    selectedData: item,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        limit: 20,
                        mid: item.mid_,
                    },
                },
                () => this.fetchPlayerData()
            );
        } else if (type === "statistics") {
            // 数据统计
            this.setState(
                {
                    title: this.props.language["dataStatistics"],
                    type,
                    show: true,
                    selectedData: item,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        mid: item.mid_,
                    },
                },
                () => this.fetchStatisticsData()
            );
        }
    };

    /**
     * 设置定时任务
     */
    setTimmer = () => {
        this.fetchRobotListData();
        this.fetchRobotBoardListData();
        this.clearTimmer();
        timer = setInterval(() => {
            this.fetchRobotListData(false);
            this.fetchRobotBoardListData(false);
        }, 10000);
    };

    /**
     * 清楚定时任务
     */
    clearTimmer = () => {
        if (timer) clearInterval(timer);
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["matchIdPlaceholder"]}
                        value={this.state.queryParams.mid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("mid", value, "data")
                        }
                    />
                    <Input
                        allowClear
                        placeholder={this.props.language["matchNamePlaceholder"]}
                        value={this.state.queryParams.name}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("name", e.target.value, "data")
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["matchStatusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("status", value, "data")
                        }
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e, "data")}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={(pagination) => this.hanldeChangePage(pagination, "data")}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["startMatchTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchId"]}
                            dataIndex="mid_"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchName"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchStatus"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (statusItem) => statusItem.value == item.status
                                )
                                    ? this.state.statusList.find(
                                        (statusItem) => statusItem.value == item.status
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["competitionType"]}
                            dataIndex="mtt_type"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchApplyFee"]}
                            dataIndex=""
                            render={(item) => `${item.entry_fee}/${item.entry_svc_fee}`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["rebootApplyFee"]}
                            dataIndex=""
                            render={(item) => `${item.reentry_fee}/${item.reentry_svc_fee}`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["repurchaseApplyFee"]}
                            dataIndex=""
                            render={(item) => `${item.rebuy_fee}/${item.rebuy_svc_fee}`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["buyMoreApplyFee"]}
                            dataIndex=""
                            render={(item) => `${item.add_on_fee}/${item.add_on_svc_fee}`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["seatNumber"]}
                            dataIndex="seat_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalSeatNumber"]}
                            dataIndex="table_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={process.env.NODE_ENV === "development" ? 560 : 450}
                            render={(item) => (
                                <>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow(item, "handCard")}
                                    >
                                        {this.props.language["handDetail"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow(item, "record")}
                                    >
                                        {this.props.language["recordDetail"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow(item, "player")}
                                    >
                                        {this.props.language["playerList"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow(item, "statistics")}
                                    >
                                        {this.props.language["dataStatistics"]}
                                    </Button>
                                    {process.env.NODE_ENV === "development" && (
                                        <Button
                                            className="ml10"
                                            type="primary"
                                            ghost
                                            icon="android"
                                            onClick={() => this.handleShow(item, "robot")}
                                        >
                                            {this.props.language["testTool"]}
                                        </Button>
                                    )}
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 详情弹窗 */}
                <DetailModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    type={this.state.type}
                    loading={this.state.detailLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.detailQueryParams.page,
                        pageSize: this.state.detailQueryParams.limit,
                        total: this.state.detailQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    detailQueryParams={this.state.detailQueryParams}
                    recordData={this.state.recordData}
                    tableBoardList={this.state.tableBoardList}
                    selectedData={this.state.selectedData}
                    playerData={this.state.playerData}
                    statusList={this.state.statusList}
                    statisticsData={this.state.statisticsData}
                    handCardData={this.state.handCardData}
                    robotListData={this.state.robotListData}
                    robotTableBoardListData={this.state.robotTableBoardListData}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    setTimmer={this.setTimmer}
                    handleRobotSignUp={this.handleRobotSignUp}
                    handleRobotCancelSignUp={this.handleRobotCancelSignUp}
                    handleOperationRobot={this.handleOperationRobot}
                    onCancel={() => {
                        this.clearTimmer();
                        this.setState({ show: false });
                    }}
                    onChange={(pagination) =>
                        this.hanldeChangePage({ current: pagination }, this.state.type)
                    }
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        );
    }
}

/**
 * 详情弹窗
 */
const DetailModal = Form.create({ name: "form_box" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;

            // 标题内容
            const titleContent = () => {
                if (this.props.type === "handCard") {
                    return (
                        <div className='container-header p0'>
                            {this.props.handCardData.hand_time && (
                                <>
                                    <span>{this.props.title}</span>
                                    <span>（{this.props.handCardData.id}）</span>
                                    <span className="mr20">
                                        {this.props.handCardData.hand_time
                                            ? this.props.handCardData.hand_time
                                            : ""}
                                    </span>
                                    <Select
                                        className="mr20"
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder={
                                            this.props.language["currentGambleTablePlaceholder"]
                                        }
                                        value={this.props.detailQueryParams.tid}
                                        onChange={(value) =>
                                            this.props.handleSetQueryParamsData(
                                                "tid",
                                                value,
                                                "handCard"
                                            )
                                        }
                                    >
                                        {this.props.tableBoardList.map((item, index) => (
                                            <Select.Option value={item.tid} key={index}>
                                                {this.props.language["gambleTable"]}
                                                {item.tid}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </>
                            )}
                            <InputNumber
                                precision={0}
                                min={0}
                                max={100000000}
                                placeholder={this.props.language["playerIdPlaceholder"]}
                                value={this.props.detailQueryParams.uid}
                                onChange={(value) =>
                                    this.props.handleSetQueryParamsData("uid", value, "handCard")
                                }
                            />
                        </div>
                    );
                } else if (this.props.type === "robot") {
                    return (
                        <Row type="flex" align="middle" justify="space-between">
                            <span>{this.props.title}</span>
                            <Button
                                style={{ marginRight: 30 }}
                                type="default"
                                icon="sync"
                                onClick={() => this.props.setTimmer()}
                            >
                                {this.props.language["refresh"]}
                            </Button>
                        </Row>
                    );
                } else {
                    return this.props.title;
                }
            };

            return (
                <Modal
                    maskClosable={false}
                    width={1600}
                    title={titleContent()}
                    visible={this.props.visible}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                        overflowY: "auto",
                    }}
                    footer={
                        this.props.type !== "statistics" && this.props.type !== "robot" ? (
                            <Pagination

                                showQuickJumper
                                {...this.props.pagination}
                                showTotal={(total) =>
                                    `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                                }
                                onChange={this.props.onChange}
                            />
                        ) : null
                    }
                >
                    <div className="container-content">
                        {/* 测试工具 */}
                        {this.props.type === "robot" && (
                            <Spin spinning={this.props.loading}>
                                <Row type="flex" justify="space-around" gutter={10}>
                                    {/* 报名工具 */}
                                    <Col span={isMobileDevice() ? 24 : 6}>
                                        <Card
                                            title={
                                                <h3>
                                                    {this.props.language["applyTool"]}
                                                </h3>
                                            }
                                            type="inner"
                                        >
                                            <Form layout="inline">
                                                <Form.Item >
                                                    {getFieldDecorator("count", {
                                                        rules: [
                                                            {
                                                                required: false,
                                                                message:
                                                                    this.props.language[
                                                                    "batchApplyPeoplePlaceholder"
                                                                    ],
                                                            },
                                                        ],
                                                    })(
                                                        <InputNumber
                                                            min={1}
                                                            max={this.props.robotListData.length}
                                                            precision={0}
                                                            placeholder={
                                                                this.props.language["batchApplyPeoplePlaceholder"]
                                                            }
                                                        />
                                                    )}
                                                </Form.Item>
                                                <Form.Item >
                                                    <Button
                                                        type="primary"
                                                        onClick={() => this.props.handleRobotSignUp("batch")}
                                                    >
                                                        {this.props.language["batchApply"]}
                                                    </Button>
                                                </Form.Item>
                                            </Form>
                                            <List
                                                className="mt10"
                                                bordered
                                                style={{
                                                    maxHeight: "calc(70vh - 165px)",
                                                    overflowY: "auto",
                                                }}
                                                dataSource={this.props.robotListData}
                                                renderItem={(item, index) => (
                                                    <List.Item>
                                                        <List.Item.Meta title={`${item.name}(${item.uid})`} />
                                                        {item.status === 0 && (
                                                            <Button
                                                                type="primary"
                                                                ghost
                                                                onClick={() =>
                                                                    this.props.handleRobotSignUp(
                                                                        "single",
                                                                        item,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                {this.props.language["apply"]}
                                                            </Button>
                                                        )}
                                                        {item.status === 1 && (
                                                            <Button
                                                                type="default"
                                                                onClick={() =>
                                                                    this.props.handleRobotCancelSignUp(item, index)
                                                                }
                                                            >
                                                                {this.props.language["cancelApply"]}
                                                            </Button>
                                                        )}
                                                        {item.status === 2 && (
                                                            <Button type="primary" disabled>
                                                                {this.props.language["participated"]}
                                                            </Button>
                                                        )}
                                                    </List.Item>
                                                )}
                                            />
                                        </Card>
                                    </Col>

                                    {/* 在玩机器人 */}
                                    <Col span={isMobileDevice() ? 24 : 18}>
                                        <Card
                                            title={
                                                <h3>
                                                    {this.props.language["playingRobot"]}
                                                </h3>
                                            }
                                            type="inner"
                                        >
                                            <List
                                                // grid={{ gutter: 16, column: 2 }}
                                                style={{
                                                    maxHeight: "calc(70vh - 60px)",
                                                    overflowY: "auto",
                                                    overflowX: "hidden",
                                                }}
                                                dataSource={this.props.robotTableBoardListData}
                                                renderItem={(item, index) => (
                                                    <List.Item>
                                                        <Card
                                                            title={
                                                                <h3>{`${this.props.language["gambleTable"]
                                                                    }${index + 1}(${item.tid})`}</h3>
                                                            }
                                                            type="inner"
                                                        >
                                                            <List
                                                                style={{
                                                                    maxHeight: "calc(70vh - 255px)" / 2,
                                                                    overflowY: "auto",
                                                                }}
                                                                dataSource={item.bot_list}
                                                                renderItem={(item2) => (
                                                                    <List.Item>
                                                                        <List.Item.Meta
                                                                            title={`${item2.name}(${item2.uid})`}
                                                                        />
                                                                        <Radio.Group
                                                                            className="mr10 mt5 mb5"
                                                                            value={item2.auto_action}
                                                                            buttonStyle="solid"
                                                                            onChange={(e) =>
                                                                                this.props.handleOperationRobot(
                                                                                    item2,
                                                                                    "action",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio.Button value={1}>
                                                                                {this.props.language["autoAllin"]}
                                                                            </Radio.Button>
                                                                            <Radio.Button value={2}>
                                                                                {this.props.language["autoFold"]}
                                                                            </Radio.Button>
                                                                            <Radio.Button value={3}>
                                                                                {this.props.language["aiPlayCard"]}
                                                                            </Radio.Button>
                                                                        </Radio.Group>
                                                                        <Radio.Group
                                                                            className="mr10 mt5 mb5"
                                                                            value={item2.auto_rebuy}
                                                                            buttonStyle="solid"
                                                                            onChange={(e) =>
                                                                                this.props.handleOperationRobot(
                                                                                    item2,
                                                                                    "rebuy",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio.Button value={true}>
                                                                                {this.props.language["autoRebuy"]}
                                                                            </Radio.Button>
                                                                            <Radio.Button value={false}>
                                                                                {this.props.language["giveUpRebuy"]}
                                                                            </Radio.Button>
                                                                        </Radio.Group>
                                                                        <Radio.Group
                                                                            className="mr10 mt5 mb5"
                                                                            value={item2.auto_add_on}
                                                                            buttonStyle="solid"
                                                                            onChange={(e) =>
                                                                                this.props.handleOperationRobot(
                                                                                    item2,
                                                                                    "addon",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        >
                                                                            <Radio.Button value={true}>
                                                                                {this.props.language["autoAddon"]}
                                                                            </Radio.Button>
                                                                            <Radio.Button value={false}>
                                                                                {this.props.language["giveUpAddon"]}
                                                                            </Radio.Button>
                                                                        </Radio.Group>
                                                                    </List.Item>
                                                                )}
                                                            />
                                                        </Card>
                                                    </List.Item>
                                                )}
                                            />
                                        </Card>
                                    </Col>
                                </Row>
                            </Spin>
                        )}

                        {/* 战绩详情 */}
                        {this.props.type === "record" && (
                            <>
                                <Card
                                    title={
                                        <h3>
                                            {this.props.language["matchStatistics"]}
                                        </h3>
                                    }
                                    type="inner"
                                >
                                    <Table
                                        dataSource={this.props.recordData.mid ? [this.props.recordData] : null}
                                        pagination={false}
                                        loading={this.props.loading}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["matchType"]}
                                            dataIndex=""
                                            render={(item) =>
                                                item.allows ? item.allows.join("+") : ""
                                            }
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["applyPeopleNumber"]}
                                            dataIndex="register_players"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["applyNumber"]}
                                            dataIndex="register_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["rebootNumber"]}
                                            dataIndex="re_buy_players"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["rebootTime"]}
                                            dataIndex="re_buy_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["repurchaseNumber"]}
                                            dataIndex="reentry_players"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["repurchaseTime"]}
                                            dataIndex="reentry_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["buyMoreTime"]}
                                            dataIndex="add_on_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["totalApplyFee"]}
                                            dataIndex="total_fee"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["totalServiceFee"]}
                                            dataIndex="total_svc_fee"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["ticketApply"]}
                                            dataIndex="entry_ticket_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["prizePool"]}
                                            dataIndex="total_bonus"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["winnerPeople"]}
                                            dataIndex="award_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["matchSeparate"]}
                                            dataIndex=""
                                            render={(item) =>
                                                item.super_union_earnings +
                                                item.union_earnings +
                                                item.club_earnings
                                            }
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["matchIncome"]}
                                            dataIndex="total_earning"
                                        />
                                    </Table>
                                </Card>
                                <Card
                                    className="mt20"
                                    title={
                                        <h3>
                                            {this.props.language["playerStatistic"]}
                                        </h3>
                                    }
                                    type="inner"
                                >
                                    <Table
                                        dataSource={this.props.recordData.winner_list ? this.props.recordData.winner_list : []}
                                        pagination={false}
                                        loading={this.props.loading}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["order"]}
                                            dataIndex="rank"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["playerId"]}
                                            dataIndex=""
                                            render={(item) => (
                                                <Link to={`/player_detail/${item.uid}/${item.club_id}`}>
                                                    {item.uid || ''}
                                                </Link>
                                            )}
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["playerName"]}
                                            dataIndex="user_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["clubId"]}
                                            dataIndex=""
                                            render={(item) => (
                                                <Link to={`/club_detail/${item.club_id}`}>
                                                    {item.club_id || ''}
                                                </Link>
                                            )}
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["clubName"]}
                                            dataIndex="club_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["unionId"]}
                                            dataIndex=""
                                            render={(item) => (
                                                <Link to={`/union_detail/${item.union_id}`}>
                                                    {item.union_id || ''}
                                                </Link>
                                            )}
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["unionName"]}
                                            dataIndex="union_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["superUnionId"]}
                                            dataIndex="super_union_id"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["superUnionName"]}
                                            dataIndex="super_union_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["prizeTicketNumber"]}
                                            dataIndex="bonus_ticket"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["chipNumber"]}
                                            dataIndex="chips"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["rebootTime"]}
                                            dataIndex="rebuy_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["repurchaseTime"]}
                                            dataIndex="reentry_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["buyMoreTime"]}
                                            dataIndex="add_on_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["award"]}
                                            dataIndex="bonus"
                                        />
                                    </Table>
                                </Card>
                            </>
                        )}

                        {/* 玩家列表 */}
                        {this.props.type === "player" && (
                            <>
                                <Table
                                    dataSource={this.props.playerData}
                                    pagination={false}
                                    loading={this.props.loading}
                                    scroll={{ x: true }}
                                    rowKey={(record, index) => index}
                                >
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["order"]}
                                        dataIndex="rank"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["playerId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/player_detail/${item.uid}/${item.club_id}`}>
                                                {item.uid || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["playerName"]}
                                        dataIndex="user_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["bonus"]}
                                        dataIndex="bonus"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["prizeTicketNumber"]}
                                        dataIndex="bonus_ticket"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["chipNumber"]}
                                        dataIndex="chips"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["repurchaseTime"]}
                                        dataIndex="reentry_num"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["rebootTime"]}
                                        dataIndex="rebuy_num"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["buyMoreTime"]}
                                        dataIndex="add_on_num"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["clubId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/club_detail/${item.club_id}`}>
                                                {item.club_id || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["clubName"]}
                                        dataIndex="club_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["unionId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/union_detail/${item.union_id}`}>
                                                {item.union_id || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["unionName"]}
                                        dataIndex="union_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["superUnionId"]}
                                        dataIndex="super_union_id"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["superUnionName"]}
                                        dataIndex="super_union_name"
                                    />
                                </Table>
                            </>
                        )}

                        {/* 数据统计 */}
                        {this.props.type === "statistics" && (
                            <>
                                <Table
                                    dataSource={[this.props.statisticsData]}
                                    pagination={false}
                                    loading={this.props.loading}
                                    scroll={{ x: true }}
                                    rowKey={(record, index) => index}
                                    bordered
                                >
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["matchId"]}
                                        dataIndex="mid_"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["matchStatus"]}
                                        dataIndex=""
                                        render={(item) =>
                                            this.props.statusList.find(
                                                (item2) => item2.value === item.status
                                            )
                                                ? this.props.statusList.find(
                                                    (item2) => item2.value === item.status
                                                ).label
                                                : ""
                                        }
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["matchDurationTime"]}
                                        dataIndex="time_range"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["totalPrize"]}
                                        dataIndex="bonus"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["rewardsNumber"]}
                                        dataIndex="award_num"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["applyPeopleNumber"]}
                                        dataIndex="register_user_num"
                                    />
                                    <Table.ColumnGroup
                                        title={this.props.language["matchTime"]}
                                        align="center"
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["apply"]}
                                            dataIndex="register_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["repurchase"]}
                                            dataIndex="reentry_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["reboot"]}
                                            dataIndex="rebuy_num"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["buyMore"]}
                                            dataIndex="addon_num"
                                        />
                                    </Table.ColumnGroup>
                                    <Table.ColumnGroup
                                        title={this.props.language["enterFee"]}
                                        align="center"
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["apply"]}
                                            dataIndex="entry_fee_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["repurchase"]}
                                            dataIndex="reentry_fee_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["reboot"]}
                                            dataIndex="rebuy_fee_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["buyMore"]}
                                            dataIndex="addon_fee_sum"
                                        />
                                    </Table.ColumnGroup>
                                    <Table.ColumnGroup
                                        title={this.props.language["serviceFee"]}
                                        align="center"
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["apply"]}
                                            dataIndex="entry_svc_fee_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["repurchase"]}
                                            dataIndex="reentry_svc_fee_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["reboot"]}
                                            dataIndex="rebuy_svc_fee_sum"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["buyMore"]}
                                            dataIndex="addon_svc_fee_sum"
                                        />
                                    </Table.ColumnGroup>
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["ticketApply"]}
                                        dataIndex="entry_ticket_sum"
                                    />
                                </Table>
                            </>
                        )}

                        {/* 手牌详情 */}
                        {this.props.type === "handCard" && (
                            <Spin spinning={this.props.loading}>
                                {this.props.handCardData.id && (
                                    <>
                                        {/* MTT */}
                                        <HandDetail
                                            {...this.props}
                                            handCardData={this.props.handCardData}
                                            squidConf={this.props.selectedData.squid_conf}
                                            searchPlayer={{
                                                uid1: this.props.detailQueryParams.uid,
                                            }}
                                        />
                                    </>
                                )}

                                {/* 暂无数据 */}
                                {!this.props.handCardData.id && (
                                    <>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                    </>
                                )}
                            </Spin>
                        )}
                    </div>
                </Modal>
            );
        }
    }
);
